// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"323":"3340fdb5","2424":"fb768bd7"}[chunkId] + ".chunk.css";
};